import React from 'react';
import { useParams } from 'wouter';
import { UseLocationScope } from '../AppLocation';
import { AccountPage } from '../account/AccountPage';
import { ManagementSwitch } from './ManagementSwitch';

export const ManagementPage = () => {
    const { section, param } = useParams<{ section: string, param: string }>();
    return <AccountPage>
        <UseLocationScope name="manage" label="Manage" />
        <ManagementSwitch section={section} param={param} />
    </AccountPage>;
};
